import { AfterViewInit, Component, Type, ViewChild, ViewContainerRef, inject } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { Objects } from 'src/modules/utils/shared/objects';
import { ButtonDefinition } from '../../models/button-definition.model';
import { Arrays } from 'src/modules/utils/shared/arrays';

@Component({
    selector: 'app-container-dialog',
    templateUrl: './container-dialog.component.html',
    styleUrls: [],
    standalone: false,
    host: {
        class: "height100p"
    }
})
export class ContainerDialogComponent implements AfterViewInit {
    
    app = inject(MainAppService);
    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);
    
    @ViewChild('host', { read: ViewContainerRef, static: true }) host!: ViewContainerRef;

    buttons: ButtonDefinition[];
    instance: ComponentView;

    async ngAfterViewInit(): Promise<void> {
        const component = this.config.data.component as Type<ComponentView>;
        const inputs = (this.config.data.inputs ?? {}) as Record<string, unknown>;
        
        const cmpRef = this.host.createComponent(component);
        this.instance = cmpRef.instance;
        this.instance.embeddedComponent = true;
        this.instance.containerDialog = this;
        for (let key of Objects.getPropertyNames(inputs)) {
            this.instance[key] = inputs[key];
        }
        await this.instance.initEmbedded();
        this.buttons = Arrays.withoutNull(this.instance.getDialogButtons() ?? []);
    }

    async click(button: ButtonDefinition): Promise<void> {
        await this.instance.buttonClickedFromExtern(button.id);
    }

    close(): void {
        this.ref.close(null);
    }
}